import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="content">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal-materials-wrapper-content {
                display: contents;
            }

            .content-container {
                width: 100%;
                max-width: 900px;
                margin: 20px auto 0;
                padding: 20px;
                display: flex;
                box-sizing: border-box;
                border: 1px solid rgba(42, 43, 82, .1);
                background: var(--background-white);
            }

            @media (min-width: 1013px) {
                .content-container {
                    box-sizing: content-box;
                }
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/content/index.js